async function getCompanyByNIP(nip) {
	const CACHE_KEY = `autofill-nip-${nip}`;
	const autofillCache = cache().getItem(CACHE_KEY);
	if (autofillCache) {
		await sleep(750);
		return autofillCache;
	}

	const token = await request_captcha('GUS_info');
	const {
		success,
		data
	} = await fetch('/wp-json/contract-form/get-company-by-nip', {
		method: 'POST',
		body: JSON.stringify({
			token,
			nip
		}),
		headers: {
			'Content-Type': 'application/json',
		}
	}).then((response) => response.json());

	if (!success) {
		throw new Error('success in response is false');
	}

	cache().setItem(CACHE_KEY, { ...data })
	return data;
}

function setupAutofill(field, form) {
	const autofillTriggerActions = ['nip'];
	const fieldset = getFieldset(field);

	field.addEventListener('blur', async () => {
		try {
			removeMessage(field);
			const isValid = validateField(field);
			if (!isValid) return;

			const triggerType = field.dataset?.autofillTrigger;
			if (!autofillTriggerActions.includes(triggerType)) {
				throw new Error('wrong trigger type');
			}

			if (triggerType === 'nip') {
				fieldset.classList.add('loading');
				const data = await getCompanyByNIP(field.value);
				const inputs = form.querySelectorAll(`[data-autofill-by="${field.name}"]`);
				const dataToFill = [...inputs].reduce((acc, input) => {
					const name = input.name;
					const autofillType = input.dataset?.autofillType ?? '';
					const value = data?.[autofillType] ?? '';
					return { ...acc, [name]: value };
				}, {});

				fillFormWithData(form, dataToFill);
			}
		} catch (error) {
			console.error('autofill error', error.message);
		} finally {
			fieldset.classList.remove('loading');
		}
	});
}
